import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { PortalRoleService } from 'src/app/services/portal-role.service';
import { environment } from 'src/environments/environment';
import { commissionStatusLabel } from './tiny-promo-labels';

interface HubPromoCommissionAdmin {
  id: string;
  promoCode?: string;
  program?: string;
  promoterEmail?: string;
  hubId?: string;
  promotionId?: string;
  requestId?: string;
  customerPaidAmount?: number;
  promoterCommissionAmount?: number;
  tinyPromoFeeAmount?: number;
  tinyPromoFeeRate?: number;
  currency?: string;
  status: string;
  earnedAt?: string;
}

@Component({
  selector: 'app-tiny-promo-commissions',
  templateUrl: './tiny-promo-commissions.component.html',
  styleUrls: ['./tiny-promo-cases.component.scss'],
})
export class TinyPromoCommissionsComponent implements OnInit {
  private readonly apiUrl = environment.apiUrl;
  commissions: HubPromoCommissionAdmin[] = [];
  loadError = false;
  loaded = false;
  canChangeStatus = false;
  statusLabel = commissionStatusLabel;

  constructor(
    private httpService: HttpService,
    private portalRoleService: PortalRoleService,
  ) {}

  async ngOnInit() {
    this.canChangeStatus = this.portalRoleService.isAdmin();
    await this.load();
  }

  async setStatus(row: HubPromoCommissionAdmin, status: string) {
    const url = `${this.apiUrl}/admin-center/hub-promo-commission/v1/${row.id}/status`;
    try {
      const updated = await this.httpService.doPost(url, { status }).toPromise();
      Object.assign(row, updated);
    } catch (error) {
      console.error('Error updating commission status: ', error);
    }
  }

  private async load() {
    try {
      const url = `${this.apiUrl}/admin-center/hub-promo-commission/v1?size=100&sort=earnedAt,desc`;
      const page = await this.httpService.doGet(url).toPromise();
      this.commissions = page?.content || [];
      this.loadError = false;
    } catch (error) {
      this.commissions = [];
      this.loadError = true;
      console.error('Error getting admin commissions: ', error);
    }
    this.loaded = true;
  }
}
